import { render, staticRenderFns } from "./huay-list-detail.vue?vue&type=template&id=c88f58fc&scoped=true"
import script from "./huay-list-detail.vue?vue&type=script&lang=js"
export * from "./huay-list-detail.vue?vue&type=script&lang=js"
import style0 from "./huay-list-detail.vue?vue&type=style&index=0&id=c88f58fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88f58fc",
  null
  
)

export default component.exports